import React, { useEffect, useState } from 'react'
import { BotIcon } from '../../../../ui/icons/botIcon.tsx'
import { BrightyCard } from './brightyCard.tsx'

export default function BrightyStartingPage() {

    type Card = {
        id: string;
        title: string;
        question: string;
    };

    const [chosen, setChosen] = useState<Card[]>([])

    function getRandomCards(cards: Card[], count: number = 4): Card[] {
        const shuffled = [...cards].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, count);
    }

    const allCards = [
        {
            id: "1",
            title: "Fattura estera senza IVA",
            question: "Ho acquistato da un fornitore europeo e la fattura è senza IVA. Devo fare qualcosa di particolare per registrarla correttamente?"
        },
        {
            id: "2",
            title: "Auto acquistata per lavoro",
            question: "Ho preso un’auto per l’attività e vorrei capire cosa posso scaricare. IVA, carburante, manutenzione... come funziona tutto?"
        },
        {
            id: "3",
            title: "Spese mediche nella dichiarazione",
            question: "Ho delle fatture per visite mediche. Posso inserirle nel 730 o servono dei requisiti particolari?"
        },
        {
            id: "4",
            title: "Corsi e aggiornamento professionale",
            question: "Sto seguendo dei corsi per migliorare le mie competenze. Posso portarli in deduzione? Anche se sono online?"
        },
        {
            id: "5",
            title: "Pagamento a collaboratore saltuario",
            question: "Ho fatto fare un lavoro occasionale a una persona che non ha partita IVA. Devo trattenere qualcosa sul compenso?"
        },
        {
            id: "6",
            title: "F24 con più imposte",
            question: "Devo pagare IVA e INPS. Posso usare un solo F24 o meglio separare i versamenti?"
        },
        {
            id: "7",
            title: "Certificazione unica per amministratore",
            question: "Stiamo preparando la CU per l’amministratore. Serve inserire qualche codice particolare? Meglio se ci spieghi cosa compilare."
        },
        {
            id: "8",
            title: "Acquisto di un bene strumentale",
            question: "Abbiamo comprato un nuovo macchinario. Quando si inizia ad ammortizzarlo e in quanto tempo va ripartita la spesa?"
        },
        {
            id: "9",
            title: "Credito d’imposta per investimenti in Sicilia",
            question: "Abbiamo investito in nuovi strumenti qui in Sicilia. Possiamo accedere al credito d’imposta per il Sud? Come si fa la richiesta?"
        },
        {
            id: "10",
            title: "Affitto di immobile intestato alla società",
            question: "La società ha un appartamento affittato. Possiamo applicare la cedolare secca o non è prevista per le aziende?"
        },
        {
            id: "11",
            title: "Fattura da fornitore UE",
            question: "Ci è arrivata una fattura da una ditta europea. Dobbiamo fare l’esterometro o ormai non serve più?"
        },
        {
            id: "12",
            title: "Scadenza dichiarazione dei redditi",
            question: "Entro quando va inviata la dichiarazione dei redditi della società? E cosa succede se si manda in ritardo?"
        }
    ];


    useEffect(() => {
        setChosen(getRandomCards(allCards))
    }, [])

    return (
        <div className=' bg-transparent flex flex-col px-8 py-6 gap-8'>
            <div className=' flex flex-col gap-2'>
                <span className=' text-heading-sm text-brandSecondary-800 font-extrabold text-center'>Fai una domanda a Brighty</span>
                <span className=' text-text-md text-brandSecondary-600 text-center'>Il supporto di cui hai bisogno per gestire al meglio la tua attività, sempre a disposizione.</span>
            </div>
            <div className=' flex flex-col gap-3'>
                <div className=' flex gap-3'>
                    {chosen.length > 0 &&
                        <>
                            <BrightyCard title={chosen[0].title} question={chosen[0].question} />
                            <BrightyCard title={chosen[1].title} question={chosen[1].question} />
                        </>
                    }
                </div>
                <div className=' flex gap-3'>
                    {chosen.length > 0 &&
                        <>
                            <BrightyCard title={chosen[2].title} question={chosen[2].question} />
                            <BrightyCard title={chosen[3].title} question={chosen[3].question} />
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
